import {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {State} from '../../../../reducers'
import {postNombreDistrito} from '../../../../actions/catalogos.actions'
import {codigoTerritorial, esNormativaV2} from '../../../../utils/normativa.utils'

interface PropiedadesFilaDistritoResuelto {
  departamento: any
  municipio: any
  distrito: any
  etiqueta?: string
}

export default function FilaDistritoResuelto({
  departamento,
  municipio,
  distrito,
  etiqueta,
}: PropiedadesFilaDistritoResuelto) {
  const {datosEmisor} = useSelector((state: State) => state.catalogos)
  const [nombre, setNombre] = useState('')

  const codigoDepartamento = codigoTerritorial(departamento)
  const codigoMunicipio = codigoTerritorial(municipio)
  const codigoDistrito = codigoTerritorial(distrito)

  useEffect(() => {
    let vigente = true
    setNombre('')
    if (!codigoDepartamento || !codigoDistrito) return
    postNombreDistrito(codigoDepartamento, codigoMunicipio, codigoDistrito).then((res) => {
      if (vigente && res?.body?.valor) setNombre(`${res.body.valor}`)
    })
    return () => {
      vigente = false
    }
  }, [codigoDepartamento, codigoMunicipio, codigoDistrito])

  if (!codigoDistrito) return null
  if (!esNormativaV2(datosEmisor)) return null

  return (
    <tr>
      <td>{etiqueta ?? 'Distrito'}:</td>
      <td>{nombre ? nombre.toUpperCase() : codigoDistrito}</td>
    </tr>
  )
}
